import React, { useEffect } from "react";
import { resetRedux } from "../../util/util";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { removeChat } from "../../util/chatBotUtils";
import { onCloseRevealRedirectionLink, handleOnCloseEvent } from "../../util/helpURLNavigation";

import CPFallbackPage from "./CPFallbackPage";
import PropTypes from "prop-types";

function Static(props) {
  const { t } = useTranslation("loginTranslation");
  useEffect(() => {
    removeChat(props.regionId, props.emailAddress);
    resetRedux();
    sessionStorage.clear();
  }, []);

  useEffect(() => {
    document.title = t(`${props.title}`);
  }, [props.title]);

  const handleClose = () => {
    handleOnCloseEvent(onCloseRevealRedirectionLink());
  };
  
  return (
      <CPFallbackPage
        windowSize={props.windowSize.width}
        ariaLabel="Session Expired"
        pageTitle={t("Session expired")}
        pageContent={t("For your security, your session has expired due to inactivity.")}
        buttonId="session-exp-verify-button"
        buttonHandler={() => handleClose()}
        buttonName={t("CLOSE")}
        buttonAriaLabel="Close"
      />
  );
}

const mapStateToProps = (state) => {
  return {
    windowSize: state.ACCOUNT.windowSize,
    emailAddress: state.ACCOUNT.emailAddress,
    regionId: state.ACCOUNT.regionId,
  };
};
Static.propTypes = {
  windowSize: PropTypes.shape({
    width: PropTypes.number.isRequired,
  }).isRequired,
  emailAddress: PropTypes.string.isRequired,
  regionId: PropTypes.string.isRequired,
  title: PropTypes.string,
};

export default connect(mapStateToProps)(Static);